module.exports = __webpack_public_path__ + "img/xb_gzh.3680a7fc.png";